import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\CommissionNote\DeleteCommissionNoteItemController::__invoke
* @see app/Http/Controllers/CommissionNote/DeleteCommissionNoteItemController.php
* @route '/api/commission-note/{commission_note}/items/{commission_note_item}'
*/
const DeleteCommissionNoteItemController = (args: { commission_note: string | number | { id: string | number }, commission_note_item: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number }, commission_note_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCommissionNoteItemController.url(args, options),
    method: 'delete',
})

DeleteCommissionNoteItemController.definition = {
    methods: ["delete"],
    url: '/api/commission-note/{commission_note}/items/{commission_note_item}',
} satisfies RouteDefinition<["delete"]>

/**
* @see \App\Http\Controllers\CommissionNote\DeleteCommissionNoteItemController::__invoke
* @see app/Http/Controllers/CommissionNote/DeleteCommissionNoteItemController.php
* @route '/api/commission-note/{commission_note}/items/{commission_note_item}'
*/
DeleteCommissionNoteItemController.url = (args: { commission_note: string | number | { id: string | number }, commission_note_item: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number }, commission_note_item: string | number | { id: string | number } ], options?: RouteQueryOptions) => {
    if (Array.isArray(args)) {
        args = {
            commission_note: args[0],
            commission_note_item: args[1],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        commission_note: typeof args.commission_note === 'object'
        ? args.commission_note.id
        : args.commission_note,
        commission_note_item: typeof args.commission_note_item === 'object'
        ? args.commission_note_item.id
        : args.commission_note_item,
    }

    return DeleteCommissionNoteItemController.definition.url
            .replace('{commission_note}', parsedArgs.commission_note.toString())
            .replace('{commission_note_item}', parsedArgs.commission_note_item.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\CommissionNote\DeleteCommissionNoteItemController::__invoke
* @see app/Http/Controllers/CommissionNote/DeleteCommissionNoteItemController.php
* @route '/api/commission-note/{commission_note}/items/{commission_note_item}'
*/
DeleteCommissionNoteItemController.delete = (args: { commission_note: string | number | { id: string | number }, commission_note_item: string | number | { id: string | number } } | [commission_note: string | number | { id: string | number }, commission_note_item: string | number | { id: string | number } ], options?: RouteQueryOptions): RouteDefinition<'delete'> => ({
    url: DeleteCommissionNoteItemController.url(args, options),
    method: 'delete',
})

export default DeleteCommissionNoteItemController